/* eslint-disable no-empty-pattern */
import React, { useState, useContext, useEffect } from "react";
import { StateContext } from "../../contextApi";
import { closeModalOnClick } from "../../util/util";
import DialIcon from '../../assets/img/kuda-dial-call.inline.svg';
import styled from "styled-components";

const DialBVNModal = () => {

    const [state, setState] = useState({
        isStopped: true,
    })

    const [{ }, dispatch] = useContext(StateContext)


    const closeModal = async () => {
        dispatch({
            key: "dialBVNForm",
            value: false,
            type: 'CHANGE_VIEW_MODALS'
        });
    }


    const handleAnim = () => {
        setState({ isStopped: false })
    }

    useEffect(() => {
        document.body.classList.add("backdrop-init");
        closeModalOnClick(closeModal);
        return () => {
            document.body.classList.remove("backdrop-init");
        }
    }, [])


    return (
        <DialBvnStyled>
            <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated">
                <div className="modal-content fadeInUp animated">
                    <div className="kuda-modal--content">
                        <h4 className="color-black text-xbold margin-bottom--spacer text-center">Dial Code</h4>

                        <div className="kuda-modal-illustration">
                            <DialIcon />
                        </div>

                        <div className="message-response withdrawal-response text-center bottom--spacing">
                            <p className="color-black">Dial this code to get your BVN.</p>
                            <p className="color-secondary text-bold mt-3">*565*0#</p>
                        </div>

                        <div className="dial-btn-wrap d-flex justify-content-center mt-5">
                            <div className="btn-cancel-dial kuda-cta-outline" onClick={closeModal}>Cancel</div>
                        </div>
                    </div>
                </div>
            </div>
        </DialBvnStyled>
    );
}

const DialBvnStyled = styled.div`

.dial-btn-wrap{
    max-width: 335px;

    .btn-cancel-dial{
        width: 100%;
    }
}

`
export default DialBVNModal;